

import {useParams} from 'react-router-dom';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useBillingProvider} from '../hooks/useBillingProvider.ts';

import {useEditPageTools} from '../hooks/useEditPageTools';

export const EditPage = () => {

    const {id: billingProviderId} = useParams();

    if (typeof billingProviderId === 'undefined') {
        throw new Error('billingProviderId is required parameter');
    }

    const {
        record: billingProvider,
        loading,
        updateRecord,
    } = useBillingProvider(billingProviderId);

    const {
        mode,
        tools,
    } = useEditPageTools();


    if (loading || !billingProvider) {
        return <PlatformLoader message='Loading billingProvider...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={billingProvider.name ? billingProvider.name : billingProvider.id}
            pageNavigation={<EditPageNavigation component={billingProvider}/>}
            tools={tools}
        >


            {mode === 'view' ?
                <Profile
                    record={billingProvider}
                />
                :
                <RecordForm
                    record={billingProvider}
                    handleSubmit={updateRecord}
                />}


        </FormPageLayout>
    );
};